









































import { Component, Vue } from 'vue-property-decorator'
import PanelGroup from './components/PanelGroup.vue'
import { ref } from '@vue/composition-api'
import OrderTable from '@/views/orders/components/OrderTable.vue'
import { getOrders, getDashboard, deleteOrder } from '@/api/orders'
import { OrdersModule } from '@/store/modules/orders'
import { IOrderData, IMetricValues } from '@/api/types'
import { notifyError, notifySuccess } from '@/utils/error-display'

@Component({
  name: 'DashboardAdmin',
  components: {
    OrderTable,
    PanelGroup
  }
})
export default class extends Vue {
  private total = 0
  private list: IOrderData[] = []
  private listLoading = true
  private title = 'Loading...'
  private currentType = 'created'
  private metrics: IMetricValues[] = []
  private searchValue = ref<string>(null)

  private handleSetLineChartData(type: string) {
    this.getList(type)
  }

  private async handleDelete(orderId: number, reason: string) {
    this.title = 'Deactivating Order, please wait...'
    const result = await deleteOrder(orderId, reason)
    if (result.startsWith('Success')) {
      notifySuccess(result)
    } else {
      notifyError(result)
    }
    this.getList(this.currentType)
  }

  created() {
    this.getList(this.currentType)
  }

  private async getList(type: string) {
    this.title = 'Loading, please wait...'
    this.total = 0
    this.listLoading = true
    const search = OrdersModule.search
    console.info(`Get List() Type ${type}, Search for ${search}`)
    const data = await getOrders(type, search)
    this.list = data
    OrdersModule.loadOrders(data)
    OrdersModule.setFilterValue(type)
    OrdersModule.setSearchValue(search)
    this.total = this.list.length
    this.listLoading = false
    this.title = this.getTitle(type)
    this.currentType = type
    this.getDashboard()
  }

  private async getDashboard() {
    const response = await getDashboard()
    this.metrics = !response.data ? [] : response.data.orderCounts
  }

  getTitle(type: string) :string {
    switch (type) {
      case 'all': return 'All Orders (including Report Created)'
      case 'inProcess': return 'All Orders In Process (Not Report Created)'
      case 'created': return 'Newly Created Orders'
      case 'assigned': return 'Vendor Assigned Orders'
      case 'accepted': return 'Vendor Accepted Orders'
      case 'unassigned': return 'Un-Assigned Orders'
      case 'pendingFloorplan': return 'Pending Floorplan'
      case 'qaPending': return 'QA Pending'
      case 'processing': return 'Processing'
      case 'completed': return 'Completed Orders'
      case 'open': return 'Open or In Process Orders'
    }
    return ''
  }

  // search additions
  private async handleReset() {
    this.searchValue.value = ''
    console.info('Reset SearchValue to ' + this.searchValue.value)
    OrdersModule.setSearchValue(null)
    this.$nextTick(() => {
      this.getList(this.currentType)
    })
  }

  private async handleSearch() {
    console.info('Handle Search for ' + this.searchValue.value)
    OrdersModule.setSearchValue(this.searchValue.value)
    this.$nextTick(() => {
      this.getList(this.currentType)
    })
  }
}
